export interface LanguageOption {
  code: string;
  name: string;
  localName: string;
}

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: 'ru', name: 'Русский', localName: 'Russian' },
  { code: 'en', name: 'English', localName: 'English' },
  { code: 'ar', name: 'العربية', localName: 'Arabic' },
];

export const FLAGS = { ru: 'russia', en: 'uk', ar: 'uae' };
